const $ = window.jQuery;

var $subMenus = $('.sub-menu');
var $menusWithSubMenus = $subMenus.closest('.menu-item');

$menusWithSubMenus.find('> a').click(function (e) {
  e.preventDefault();
  $(this).closest('.menu-item').toggleClass('open');
});
